module.exports = __webpack_public_path__ + "media/components/outside-promo-page/static/mountainbikers-ff7ead6627aba2ee2290f58af8a151be.webp";